(function(angular){
  'use strict';

  angular.module('onvio.reports').controller('onvio.reports.onvioUsageCtrl', onvioUsageCtrl, 'wj');
  onvioUsageCtrl.$inject = ['$http','onvio.reports.onvioUsageService', '$scope', '$log', '$uibModal', '$translate', '$q', '$timeout', '$rootScope', '$window', 'bmAccess', 'bmPermission'];

function onvioUsageCtrl($http, onvioUsageService, $scope, $log, $uibModal, $translate, $q, $timeout, $rootScope, $window, bmAccess, bmPermission){

	/*jshint validthis:true */
	var vm = this;
	$scope.isLoader1Busy = false;
	vm.gridSelect = [];
	vm.openStartDatePicker = openStartDatePicker;
	vm.openEndDatePicker = openEndDatePicker;
	vm.openLoginHistoryModal = openLoginHistoryModal;
	vm.gridData = new wijmo.collections.CollectionView(); // jshint ignore:line

	vm.totalItems = 0;
	vm.pageSize = 25;
	vm.page = 1;
	vm.maxExportDataSize = 2000;

	vm.dateRangeExceeded = false;
	vm.startDatePickerOpened = false;
	vm.endDatePickerOpened = false;

	vm.dateToday = new Date();
	vm.endDate = vm.dateToday;
	vm.startDate = moment(vm.dateToday).subtract(30, 'days').toDate(); // jshint ignore:line
	vm.minStartDate = moment(vm.dateToday).subtract(12, 'months').toDate(); // jshint ignore:line
	/* If the user has Granular Perms FRP and IAC is present, show GP events grid */
	permissionAndAccess().then(function(resps){
		vm.granularPermsAccess = resps[0] === true && resps[1] === true && resps[2] === true;
	});
	getSideNavPermission().then(function(resp) {
		vm.useSideNav = resp;
	});
	vm.startDatePickerOptions = {
		maxDate: vm.dateToday,
		minDate: vm.minStartDate
	};

	vm.endDatePickerOptions = {
		minDate: vm.startDate,
		maxDate: vm.dateToday
	};

	$timeout(updateTranslations);
	$rootScope.$on('bmLanguageChangeSuccess', updateTranslations);

	function loadReportData(report, startDate, endDate) {
		$scope.isLoader1Busy = true;
		onvioUsageService.loadReport(report, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD')).then(function(result){// jshint ignore:line
			var reportData = result.data.items;
			if( angular.isDefined(reportData) && reportData.length > 0 ) {
				reportData.forEach(formatColumns);
				vm.totalItems = reportData.length;
			}
			vm.gridData = new wijmo.collections.CollectionView(reportData); // jshint ignore:line
			if( report === 'audit-events'){
				vm.gridData.sortDescriptions.push(new wijmo.collections.SortDescription('eventTimestamp', false)); // jshint ignore:line
			} else if (report === 'registration-status') {
				sortRegistrationStatusColumns();
			}
			vm.gridData.sortDescriptions.push(new wijmo.collections.SortDescription('loginTime', false)); // jshint ignore:line
			vm.initializeGrid();
			$scope.isLoader1Busy = false;
			refreshGridPage();

		}, function(error) {
				$scope.isLoader1Busy = false;
				// Hide error alert if http request is forcibly cancelled
				if (error.xhrStatus === 'abort') {
					error.config.global = false;
					$scope.isLoader1Busy = true;
				}
				$log.error(error);
				var reportData = [];
				vm.gridData = new wijmo.collections.CollectionView(reportData); // jshint ignore:line
				vm.initializeGrid();
		});
	}

	function sortRegistrationStatusColumns() {
		vm.gridData.sortConverter = function(event, value){
			var selectedColumn = event.property;
			if (!columnIsDate(selectedColumn)){
				return value[selectedColumn];
			} else if (dateIsPending(value[selectedColumn])){
				return oneDayFromNow();
			} else {
                return $window.moment.utc(value[selectedColumn]).format('L LT');
			}
		};
	}

	function columnIsDate(column) {
		return column === 'registrationSent' || column === 'registrationDate';
	}

	function dateIsPending(dateString) {
		return dateString === vm.registrationDatePending;
	}

	function oneDayFromNow() {
		var oneDayInMillis = 86400000;
		return new Date(Date.now() + oneDayInMillis);
	}

	function formatColumns(item) {
		formatName(item);
		formatDate(item);
		// Short term fix. This should come from backend or it should be a pipe
		if (vm.selectedItem.report === 'registration-status') {
			translateData(item);
		}
	}

	function translateData(item) {
		item.status = item.status === 'Active' ? vm.userStatusActive : vm.userStatusInactive;
		item.userType = vm.userTypeTranslation[item.userType];
	}

	function updateTranslations() {
		if(vm.flexGridFilter){
			vm.flexGridFilter.showFilterIcons = false;
		}
		onvioUsageService.getTranslations().then(function(translations) {
			if(translations) {
			/*Bento Toolbar*/
			vm.exportLabel = translations[0];
			vm.toolbarButtons = [{
				label: vm.exportLabel,
				icon: 'bento-icon-exit',
				action: function() {
					vm.exportExcel(vm.selectedItem.name);
				}
			}];
			/*Grid Names*/
			vm.activeUserSessions = translations[1];
			vm.loginHistory = translations[2];
            vm.registrationStatus = translations[4];
			/*Column Headers*/
			vm.loginHeader = translations[5];
			vm.fullNameHeader = translations[6];
			vm.loginTimeHeader = translations[7];
			vm.ipAddressHeader = translations[8];
			vm.versionHeader = translations[9];
			vm.acceptedDateHeader = translations[10];
			vm.showHideColumns = translations [11];
			vm.lastLogin = translations [12];
			vm.actionHeader = translations[13];
			vm.tooltip = translations[14];
			vm.permGroupHistory = translations[16];
			vm.changeHeader = translations[17];
			vm.permGroupHeader = translations[18];
			vm.changedByHeader = translations[19];
			vm.dateHeader = translations[20];
            vm.codeHeader = translations[21];
            vm.contactTypeHeader = translations[22];
            vm.emailHeader = translations[23];
            vm.registrationSentHeader = translations[24];
            vm.registrationDateHeader = translations[25];
			vm.statusHeader = translations[26];
			vm.registrationDatePending = translations[27];
			vm.userStatusActive = translations[28];
			vm.userStatusInactive = translations[29];
			vm.userTypeTranslation = {
				Client: translations[32],
				Staff: translations[31],
				Standalone: translations[30]
			};
			buildGrids();
		}
		});
	}

	// invalidate all Wijmo controls
   // using a separate function to handle strange IE9 scope issues
   function invalidateAll() {
      wijmo.Control.invalidateAll(); // jshint ignore:line
   }

	function buildGrids() {
			/*Grids*/
			vm.gridSelect = [
				{
					'name': vm.activeUserSessions,
					'report': 'active-sessions',
					'columns': [
						{ header : vm.emailHeader, binding : 'loginEmail', width : '*'},
						{ header : vm.fullNameHeader, binding : 'fullName', width : '*'},
						{ header : vm.loginTimeHeader, binding : 'loginTime', width : 240},
						{ header : vm.ipAddressHeader, binding : 'ipAddress', width : 200}
					],
					'selected': 'true',
				},
				{
					'name': vm.loginHistory,
					'report': 'login-histories',
					'columns': [
						{ header : vm.actionHeader, isActions: true, binding: 'history', width: 100},
						{ header : vm.emailHeader, binding : 'loginEmail', width : '*'},
						{ header : vm.fullNameHeader, binding : 'fullName', width : '*'},
						{ header : vm.lastLogin, binding : 'formattedLoginTime', width : 240},
						{ header : vm.ipAddressHeader, binding : 'ipAddress', width : 200}
					],
					'selected': 'false',
					datePickEnabled: true
				},
				{
                    'name': vm.registrationStatus,
                    'report': 'registration-status',
                    columns: [
                        { header : vm.codeHeader, binding : 'code', width : '3*'},
                        { header : vm.fullNameHeader, binding : 'fullName', width : '3*'},
                        { header : vm.contactTypeHeader, binding : 'userType', width : '2*'},
                        { header : vm.emailHeader, binding : 'loginEmail', width : '5*'},
                        { header : vm.registrationSentHeader, binding : 'registrationSent', width : 160},
                        { header : vm.registrationDateHeader, binding : 'registrationDate', width : 160},
                        { header : vm.statusHeader, binding : 'status', width : 80}
                    ],
                    'selected': 'false'
                }
			];
			vm.sideNavItems = [
				{
                    label: vm.activeUserSessions,
                    qeId: 'onvio-usage-active-sessions-tab',
					selected: true,
				}, {
                    label: vm.loginHistory,
                    qeId: 'onvio-usage-login-history-tab',
				}, {
                    label: vm.registrationStatus,
                    qeId: 'onvio-usage-registration-status-tab',
				}
			];
			if(vm.granularPermsAccess) {
				vm.gridSelect.push(
					{
						'name': vm.permGroupHistory,
						'report': 'audit-events',
						columns: [
							{ header : vm.dateHeader, binding : 'eventTimestamp', width : '*'},
							{ header : vm.changeHeader, binding : 'metadata.change', width : '*'},
							{ header : vm.permGroupHeader, binding : 'metadata.permissionGroup', width : '*'},
							{ header : vm.changedByHeader, binding : 'metadata.changedBy', width : '*'},
							{ header : vm.ipAddressHeader, binding : 'clientIp', width : 200}
						],
						'selected': 'false',
						datePickEnabled: true
					}
				);
				vm.sideNavItems.push({
                    label: vm.permGroupHistory,
                    qeId: 'onvio-usage-perm-history-tab',
				});
			}
			vm.selectedItem = vm.gridSelect[0];
			loadReportData(vm.selectedItem.report, vm.startDate, vm.endDate);
	}

	function permissionAndAccess() {
		return $q.all([bmPermission.has('Platform.GranularPermissionsAudit'), bmPermission.has('Platform.GranularPermissions'), bmAccess.has('Platform_GranularPermissions')]).then(function(resps){
			return resps;
		});
	}

	function getSideNavPermission() {
        return $q.all([
            bmPermission.has('Internal.SidenavTree').catch(() => false),
            bmAccess.has('OnvioCenterRevertSideNavEnhancements').catch(() => false)
        ]).then(([showSidenav, revertSidenav]) => {
            return showSidenav && !revertSidenav;
        });
	}

	function formatDate(item) {
		var dateFormat = 'L LT';
		if(vm.selectedItem.report === 'login-histories') {
			item.formattedLoginTime = $window.moment(item.loginTime).format(dateFormat); // jshint ignore:line
		}
		if(vm.selectedItem.report === 'active-sessions') {
			item.loginTime = $window.moment(item.loginTime).format(dateFormat); // jshint ignore:line
		}
		if(vm.selectedItem.report === 'audit-events') {
			item.eventTimestamp = $window.moment(item.eventTimestamp).format(dateFormat); // jshint ignore:line
		}
		if (vm.selectedItem.report === 'registration-status') {
			// Format registrationSent and registrationDate columns to display in local time
			// Force en-US locale, because when formating locale string for pt-BR the date is not displayed correctly
			const registrationSentLocalTime = (new Date(item.registrationSent)).toLocaleString('en-US',{hour12:true});
			item.registrationSent = $window.moment.utc(registrationSentLocalTime).format(dateFormat); // jshint ignore:line
			if (item.registrationDate) {
				const registrationDateLocalTime = (new Date(item.registrationDate)).toLocaleString('en-US', { hour12: true });
				item.registrationDate = $window.moment.utc(registrationDateLocalTime).format(dateFormat); // jshint ignore:line
			} else {
				item.registrationDate = vm.registrationDatePending;
			}
        }
	}

	function formatName(item) {
		if(item.givenName !== '' && item.familyName !== '') {
			item.fullName = item.givenName + ' ' + item.familyName;
		}
		if(vm.selectedItem.report === 'audit-events') {
			item.metadata = JSON.parse(item.metadata);
		}
	}

	vm.initializeGrid = function() {
		var flex = vm.flex;
		if (flex) {
			vm.flex.showSort = true;
			try {
				vm.flexGridFilter = new wijmo.grid.filter.FlexGridFilter(flex); // jshint ignore:line
				vm.flexGridFilter.defaultFilterType = wijmo.grid.filter.FilterType.Value; // jshint ignore:line
				vm.flexGridFilter.showFilterIcons = false;
			} catch (error) {
				console.log('Error initializing Flex Grid filter', error);
			}
			/*Setup filter*/

			/*Add handler to stop flexgrid overwriting column headers*/
			flex.formatItem.addHandler(function(s, e) {
				var col = flex.columns[e.col];
				if (!vm.flexGridFilter.showFilterIcons && e.panel.cellType === wijmo.grid.CellType.ColumnHeader) { // jshint ignore:line
					if (col.currentSort === '+') {
						e.cell.innerHTML = col.header + ' <span style="display: inline;" class="wj-glyph-up"></span>';
					} else if (col.currentSort === '-') {
						e.cell.innerHTML = col.header + ' <span style="display: inline;" class="wj-glyph-down"></span>';
					}
				}
			});
			flex.loadedRows.addHandler(function() {
				setTimeout(function() {
					var headerCells = document.querySelectorAll('.wj-cell.wj-header.wj-filter-off');
					headerCells.forEach(function(cell) {
						if (cell instanceof HTMLElement && cell.tabIndex === -1) {
							cell.tabIndex = 0;
							cell.setAttribute('aria-sort', 'none');
							cell.setAttribute('role', 'columnheader');
							cell.setAttribute('aria-label', cell.innerText);
							cell.addEventListener('keydown', function(event) {
								if (event.key === 'Enter' || event.key === ' ') {
									event.preventDefault();
									event.stopPropagation();
									var colIndex = Array.prototype.indexOf.call(cell.parentElement.children, cell);
									var col = flex.columns[colIndex];
									var existingSort = flex.collectionView.sortDescriptions.find(function(sd) {
										return sd.property === col.binding;
									});
									var newSortDirection;
									if (existingSort) {
										newSortDirection = !existingSort.ascending;
									} else {
										newSortDirection = true;
									}
									flex.collectionView.sortDescriptions.clear();
									flex.collectionView.sortDescriptions.push(new wijmo.collections.SortDescription(col.binding, newSortDirection)); //jshint ignore:line
									cell.setAttribute('aria-sort', newSortDirection ? 'ascending' : 'descending');
									if (newSortDirection) {
										cell.setAttribute('aria-label', cell.innerText.trim() + ', sorted ascending');
									} else {
										cell.setAttribute('aria-label', cell.innerText.trim() + ', sorted descending');
									}
								} else if (event.key === 'Tab') {
									event.preventDefault();
									moveFocusToNextColumnHeader(cell);
								}
							});
							cell.addEventListener('focus', function() {
								cell.style.backgroundColor = '#d4ebf4';
							});
							cell.addEventListener('blur', function() {
								cell.style.backgroundColor = '';
							});
						}
					});
					function moveFocusToNextColumnHeader(currentCell) {
						var nextCell = currentCell.nextElementSibling;
						if (nextCell && nextCell.tabIndex === 0) {
							nextCell.focus();
						} else {
							var elementOutofGrid = document.querySelector(
								'a.btn.btn-default.paginate_child_button[role="button"][aria-labelledby="goToFirstPage"]');
							if (elementOutofGrid) {
								elementOutofGrid.focus();
							}
						}
					}
				}, 0);
			});
			if (vm.selectedItem && vm.selectedItem.report === 'login-histories') {
				flex.itemFormatter = function(panel, r, c, cell) {
					if (panel.cellType === wijmo.grid.CellType.Cell && panel.columns[c].binding === 'history') { // jshint ignore:line
						var contactId = this.itemsSource.items[r].contactId;
						var name = this.itemsSource.items[r].fullName;
						var email = this.itemsSource.items[r].loginEmail;
						$(cell).off('click.onvio-usage-login'); // jshint ignore:line
						$(cell).on('click.onvio-usage-login', '#elem', function() { // jshint ignore:line
							vm.openLoginHistoryModal(email, name, contactId);
						});
						$(cell).css('text-align', 'center'); // jshint ignore:line
					}
				};
			}
			// show changes
			flex.refresh();
		}
	};
	function openLoginHistoryModal(email, name, userId){
		$uibModal.open({
			templateUrl: 'reports/onvio-usage/login-history-modal/login-history-modal.2js.html',
			controller: 'LoginHistoryCtrl as vm',
			size: 'lg',
			backdrop: 'static',
			resolve: {
				userId: function() {
					return userId;
				},
				email: function() {
					return email;
				},
				name: function() {
					return name;
				}
			}
		});
	}
	function openStartDatePicker() {
		vm.startDatePickerOpened = !vm.startDatePickerOpened;
	}
	function openEndDatePicker() {
		vm.endDatePickerOpened = !vm.endDatePickerOpened;
	}
	function dateRangeExceeded() {
		return moment(vm.startDate).isBefore(moment(vm.endDate).subtract(30, 'days')); // jshint ignore:line
	}
	vm.dateRangeChanged = function(item) {
		vm.startDatePickerOptions.maxDate = vm.endDate;
		vm.endDatePickerOptions.minDate = vm.startDate;
		if( !dateRangeExceeded() ) {
			vm.gridData.refresh();
			vm.dateRangeExceeded = false;
			loadReportData(item.report, vm.startDate, vm.endDate);
		} else {
			vm.dateRangeExceeded = true;
		}
	};
	vm.selectedItemChanged = function(item) {
		if(vm.flexGridFilter){
			vm.flexGridFilter.showFilterIcons = false;
		}
        vm.dateRangeExceeded = false;
        // check whether the selected tab corresponds to login history and avoid
        // loading the reportData when the date range is exceeded
        if (item.report === 'login-histories' && dateRangeExceeded()) {
            vm.dateRangeExceeded = true;
        } else {
            loadReportData(item.report, vm.startDate, vm.endDate);
        }
		vm.selectedItem.selected = false;
		vm.selectedItem = item;
		vm.selectedItem.selected = true;
    };
    vm.selectedItemKeydown = function(event, item) {
        if(event.key && (event.key === 'Space' || event.key === 'Enter')) {
            vm.selectedItemChanged(item);
        }
    };
	vm.sideNavSelectedItemChanged = function(treeItem) {
		const gridItem = vm.gridSelect.find(item => item.name === treeItem.label);
		vm.selectedItemChanged(gridItem);
	};
	vm.toggleVisibility = function(column) {
		column.visible = !column.visible;
    };
    vm.handleColumnKeydown = function(event, column) {
        if(event.key && (event.key === 'Space' || event.key === 'Enter')) {
            vm.toggleVisibility(column);
		}
	};
	vm.onDropdownBlur = function(event) {
		var options = Array.from(document.querySelectorAll('.onvio-usage-dropdown-menu > a'));
		options.push(document.querySelector('.onvio-usage-dropdown'));
		if(!options.includes(event.relatedTarget)) {
			vm.onDropdownToggle(false);
		}
	};
	vm.onDropdownToggle = function(open) {
		vm.isOpen = open;
	};
	vm.toggleFilterVisibility = function() {
		var flexGridFilter = vm.flexGridFilter;
		if(flexGridFilter){
			if( angular.isDefined(flexGridFilter.showFilterIcons) ) {
				flexGridFilter.showFilterIcons = !flexGridFilter.showFilterIcons;
				try {
					var actionCol = flexGridFilter.getColumnFilter('history');
					actionCol.filterType = wijmo.grid.filter.FilterType.None; // jshint ignore:line
				} catch (error){

				}
			}
		}
		invalidateAll();
	};
	vm.exportExcel = function(reportName) {
		var currentPageSize = vm.flex.collectionView.pageSize;
		var pageSizeChanged = false;
		if (currentPageSize < vm.totalItems) {
			vm.flex.collectionView.pageSize = vm.maxExportDataSize;
			pageSizeChanged = true;
		}
		wijmo.grid.xlsx.FlexGridXlsxConverter.saveAsync(vm.flex, { includeCellStyles: false }, reportName.replace(/[\s]/g, '') + '.xlsx'); // jshint ignore:line
		if (pageSizeChanged) {
			vm.flex.collectionView.pageSize = currentPageSize;
			vm.pageSize = currentPageSize;
			refreshGridPage();
		}
	};

	$scope.$watch('vm.flex', function() {
		setupPagination();
	});

	function setupPagination() {
		if (vm.flex) {
			$scope.$watch('vm.page', function(page) {
				vm.flex.collectionView.moveToPage(page - 1);
				vm.flex.refresh();
			});

			$scope.$watch('vm.pageSize', function(pageSize) {
				vm.flex.collectionView.pageSize = pageSize;
				vm.pageSize = pageSize;
				refreshGridPage();
			});
		}
	}

	function refreshGridPage() {
		vm.gridData.pageSize = vm.pageSize;
	}

	vm.currentPage = 1;
	vm.changePage = function(page) {
		vm.currentPage = page;
		vm.flex.collectionView.moveToPage(page - 1);
		vm.flex.refresh();
	};
	vm.pageSizeOption = [
		{ value: 25, label: 25 },
		{ value: 50, label: 50 },
		{ value: 100, label: 100 }
	];
	vm.changePageSize = function(size) {
		vm.pageSize = size;
	};
}
})(window.angular);
